import { render, staticRenderFns } from "./LucideIcon.vue?vue&type=template&id=394c1e6c&scoped=true"
import script from "./LucideIcon.vue?vue&type=script&lang=js"
export * from "./LucideIcon.vue?vue&type=script&lang=js"
import style0 from "./LucideIcon.vue?vue&type=style&index=0&id=394c1e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394c1e6c",
  null
  
)

export default component.exports